/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import Pagination from './pagination/Pagination'
import PaginationProvider from './pagination/PaginationProvider'
import SelectionProvider from './selection/SelectionProvider'
import { PropsWithChildren, ReactNode } from 'react'
import { UseSelectionHook } from './selection/useSelection'
import { UsePaginationHook } from '../hooks/usePagination'
import { Card, Stack } from '@mantine/core'

export type ListCardProps<T> = PropsWithChildren & {
  filters?: ReactNode;
  pagination: UsePaginationHook;
  selection: UseSelectionHook<T>;
  selectionActions?: ReactNode;
  toolbar?: ReactNode;
}

function ListCard<T> (props: ListCardProps<T>) {
  const {
    children,
    filters,
    pagination,
    selection,
    selectionActions,
    toolbar
  } = props

  return (
    <SelectionProvider context={selection}>
      <PaginationProvider context={pagination}>
        <Card shadow="sm">
          <Stack>
            {toolbar}
            {filters}
            {children}
            {selectionActions}
            <Pagination />
          </Stack>
        </Card>
      </PaginationProvider>
    </SelectionProvider>
  )
}

export default ListCard
